import React from 'react'
import { useSelector } from 'react-redux'
import capitalize from 'lodash/capitalize'

import { H2 } from '@piconetworks/pkg-heading'
import Picon from '@piconetworks/pkg-picon'

import { useFeatureManager } from 'features/FeatureManager'
import useUserId from 'hooks/useUserId'
import usePublisherId from 'hooks/usePublisherId'

import IntegrationsModule from 'modules/integrations'

import IntegrationInstallerDefault from './IntegrationInstaller'
import IntegrationInstallerDev from './IntegrationInstaller.dev'

const IntegrationInstaller = ['development', 'staging'].includes(process.env.STAGE) ? IntegrationInstallerDev : IntegrationInstallerDefault

import styles from './ExternalIntegrationConnect.module.scss'


// Component for displaying external apps like Stripe
const ExternalIntegrationConnect = ({ appLabel }) => {
    const userId = useUserId()
    const publisherId = usePublisherId()

    const { getAppByLabel } = useFeatureManager({
        userId,
        publisherId,
    })

    const app = getAppByLabel(appLabel)
    const { installableApps } = app
    
    const AppInfo = ({
        installableApps = [],
    }) => {
        return (
            <>
                {installableApps?.reduce((acc, app) => {
                    const { icon, label, name, ExternalAppUsage } = app
                    const appName = capitalize(label)

                    const connectedExternalAccount: { id: string, name: string, type: string } = useSelector(IntegrationsModule.selectors[`get${appName}`])

                    acc.push(
                        <div key={label}>
                            <div className={styles.appOverview}>
                                <div className={styles.IntegrationDetails}>
                                    <span className={styles.icon}><Picon icon={icon} size="48" /></span>
                                    <div className={styles.appInfo}>
                                        <h2>{name}</h2>
                                        {connectedExternalAccount?.id && (
                                            <span>
                                                <div>Connected as {connectedExternalAccount?.name}</div>
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.cta}>
                                    <IntegrationInstaller app={app} connectedExternalAccount={connectedExternalAccount} />
                                </div>
                            </div>
                            {ExternalAppUsage && connectedExternalAccount?.id && (
                                <ExternalAppUsage />
                            )}
                        </div>
                    )

                    return acc
                }, [])}
            </>
        )
    }

    return (
        <section className={styles.planContainer}>
            <div className={styles.header}>
                <H2>Integrations</H2>
            </div>
            <div className={styles.divider} />
            <AppInfo installableApps={installableApps} />
        </section>
    )
}
export default ExternalIntegrationConnect
